<template>
  <div>
    <div class="project-container">
  <!-- <a class="embedly-card" data-card-controls="0" href="https://github.com/tuftsanti/periodic-table-frontend">tuftsanti/periodic-table-frontend</a> -->
      <h1>My Projects on Github</h1>
      <div v-for="github in githubs" :github="github" :key="github.id" class="project">
        <GithubCard :github="github"/>
      </div>
    </div>
    <div class="project-container">
      <h1>My Medium Articles</h1>
      <div v-for="medium in mediums" :medium="medium" :key="medium.title" class="project">
        <MediumCard :medium="medium"/>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import GithubCard from '@/components/GithubCard';
import MediumCard from '@/components/MediumCard';
// import getter from '@/services/getter.js';
// import axios from 'axios';
export default {
  name: 'Main',
  props: {
    msg: String
  },
  components: {
    GithubCard,
    MediumCard
  },
  data () {
    return {
      githubs: [
        {
          id: 1,
          name: "Spectro Incoming Oil Database (DEMO)",
          description: "The DEMO version of a full stack oil database manager",
          type: "MERN / React Table / NodeJS / MongoDB",
          url: "https://incoming-oil-database.netlify.app/oils/list",
          livelink: "https://incoming-oil-database.netlify.app/oils/list"
        },
        {
          id: 2,
          name: "credit-card-validator",
          description: "A simple credit card number validator",
          type: "React",
          url: "https://github.com/tuftsanti/credit-card-validator",
          livelink: "https://ccvalidator.netlify.app/"
        },
        {
          id: 3,
          name: "periodic-table-frontend",
          description: "The frontend component to my list version of the periodic table of elements.",
          type: "VueJS",
          url: "https://github.com/tuftsanti/periodic-table-frontend",
          livelink: "https://andys-periodic-table.netlify.app/"
        },
        {
          id: 4,
          name: "periodic-table-backend",
          description: "The backend component to my list version of the periodic table of elements.",
          type: "NodeJS / MongoDB",
          url: "https://github.com/tuftsanti/periodic-table-backend",
          livelink: "https://andys-periodic-table.herokuapp.com/"
        },
        {
          id: 5,
          name: "bookmarks_frontend",
          description: "The frontend of my joint bookmarking app",
          type: "Vanilla JS / JSX",
          url: "https://github.com/tuftsanti/bookmarks_frontend",
          livelink: "https://andys-bookmarks.netlify.app/"
        },
        {
          id: 6,
          name: "bookmarks_backend",
          description: "The backend of my joint bookmarking app",
          type: "NodeJS / MongoDB",
          url: "https://github.com/tuftsanti/bookmarks_backend",
          livelink: "https://andysbookmarks.herokuapp.com/bookmarks"
        },
        {
          id: 7,
          name: "project2",
          description: "My non-live utorrent database of live shows",
          type: "Vanilla JS / JSX",
          url: "https://github.com/tuftsanti/project2",
          livelink: "https://andysfirstapp.herokuapp.com/list/"
        }, 
        {
          id: 8,
          name: "Captains-Log",
          description: "A RESTful JSX app created to mimic the Captain's Log in Star Trek",
          type: "Vanilla JS / JSX / NodeJS / MongoDB",
          url: "https://github.com/tuftsanti/Captains-Log",
          livelink: "https://andycaptainslog.herokuapp.com/"
        },       
      ],
      mediums: [
        {
          id: 1,
          title: "I’m burned out man, and I haven’t even started working yet!",
          blurb: "I’ll keep this one short. I’m done. Not with life, work, or being happy, I’m just done. Either you’ve checked out already (completely…",
          published: "Published on Jun 16 - 2 min read",
          url: "https://medium.com/@ariecker/im-burned-out-man-and-i-haven-t-even-started-working-yet-1a464aa8d8eb"
        },
        {
          id: 2,
          title: "The Frustrations Of A New (Old) Coder",
          blurb: "I’m on edge right now, and I only partly comprehend the reason why. If you read my previous post, you’d know I’m making the mid-life…",
          published: "Published on Jun 3 - 3 min read",
          url: "https://medium.com/@ariecker/the-frustrations-of-a-new-old-coder-4e7edde3e298"
        },
        {
          id: 3,
          title: "Thinking about a Bootcamp? What I thought I knew but didn’t.",
          blurb: "After being laid off for what felt like the millionth time, I’d finally made the decision I’d toyed with for almost 20 years. It’s time to…",
          published: "Published on May 20 - 4 min read",
          url: "https://medium.com/@ariecker/thinking-about-a-bootcamp-what-i-thought-i-knew-but-didnt-5497b6f2a4d9"
        },
      ]
    }  
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
#codetochem {
  width: 90%;
  max-height: 300px;
}
h1 {
  background-color: ghostwhite;
  padding: 10px;
  color: #2c3e50;
  font-weight: bold;
}
</style>
